import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Alert, IconButton, Stack } from '@mui/material';
import { useTranslations, useUser } from 'hooks';
import { getTranslation } from 'common';
import { baseApi } from 'api';
import Footer from 'components/Footer';
import { useNavigate } from 'react-router-dom';
import FlowentiLogo from "../image/Logo.svg"; //# use this cause is without background
import FlowentiButton from 'components/flowenti-ui-kit/FlowentiButton';

const Support: React.FC = () => {
  const user = useUser()
  const [message, setMessage] = useState('');
  const [email, setEmail] = useState(user?.email || '');
  const [subject, setSubject] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');
  const translations = useTranslations()
  const navigate = useNavigate();
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSubmitted(false);

    try {
      setSending(true);
      const payload = {
        to_name: "",
        to_email: "support@flowenti.com",
        subject,
        message: `${message}\n\nEmail utente: ${user?.email || email}`,
        email_type: 'support'
      };
      const response = await baseApi.post('/mail/support', payload);

      if (response.status === 200 || response.status === 202) {
        setSubmitted(true);
        setMessage('');
        setSubject('');
        if (!user?.email) setEmail('');
      } else {
        setError(getTranslation(translations, "send_support.error"));
      }
    } catch (err) {
      setError(getTranslation(translations, "support_support.server.error"));
    } finally {
      setSending(false);
    }
  };

  return (
    <Stack sx={{
      minHeight: '100vh',
      overflowY: "auto",
    }}>
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          maxWidth: 600,
          mx: 'auto',
          // mt: 4,
          px: 2,
          flexGrow: 1,
        }}
      >
        <Box display="flex" alignItems="center" mb={2}>
          <Box display="flex" alignItems="center">
            <Typography sx={{
              fontFamily: "Poppins-Light",
              fontWeight: 400,
              fontSize: { xs: "24px", sm: "32px", md: "50px" },
              color: "black",
              cursor: "pointer",
            }}
              onClick={() => navigate('/dashboard/organizations')}>
              Flowenti
            </Typography>
            <IconButton onClick={() => navigate('/dashboard/organizations')}>
              <Box
                component="img"
                alt="..."
                sx={{
                  width: { xs: "44px", sm: "60px", md: "88px" },
                  height: { xs: "44px", sm: "60px", md: "88px" },
                }}
                src={FlowentiLogo}
              />
            </IconButton>
          </Box>
          {/* <Typography variant="h5" gutterBottom>
            {getTranslation(translations, "support.title")}
          </Typography> */}
        </Box>

        <TextField
          id="support-email"
          label="Email"
          type="email"
          fullWidth
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          margin="normal"
          disabled={!!user?.email}
        />

        <TextField
          id='support-object'
          label={getTranslation(
            translations,
            "generic_email.subject"
          )}
          fullWidth
          required
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          margin="normal"
        />

        <TextField
          id="support-message"
          label={getTranslation(
            translations,
            "generic_email.message"
          )}
          multiline
          rows={6}
          fullWidth
          required
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          margin="normal"
        />

        <FlowentiButton id="send-support" type="submit" variant="contained" sx={{ mt: 2, mb: 2 }} disabled={sending}>
          {sending ?
            `${getTranslation(translations, "generic.sending.caption")}` : `${getTranslation(translations, "generic.send.caption")}`
          }
        </FlowentiButton>

        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}

        {submitted && (
          <Alert severity="success" sx={{ mt: 2 }}>
            {getTranslation(translations, "support_message.sent")}
          </Alert>
        )}
      </Box>

      <Footer />
    </Stack>
  );
};

export default Support;